import { render } from "./NearbyTrailerResultCard.vue?vue&type=template&id=06bbad09&scoped=true&ts=true"
import script from "./NearbyTrailerResultCard.vue?vue&type=script&lang=ts"
export * from "./NearbyTrailerResultCard.vue?vue&type=script&lang=ts"

import "./NearbyTrailerResultCard.vue?vue&type=style&index=0&id=06bbad09&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bbad09"]])

export default __exports__